import { useState } from 'react';

interface Props {
  src: string;
  alt: string;
  className?: string;
  eager?: boolean;
  srcSet?: string;
  sizes?: string;
  priority?: 'high' | 'low' | 'auto';
}

// Image inside a fixed frame; shows a stone placeholder until loaded (no layout shift).
export default function Img({ src, alt, className = '', eager = false, srcSet, sizes, priority = 'auto' }: Props) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`img-frame relative ${className}`}>
      <img
        src={src}
        srcSet={srcSet}
        sizes={srcSet ? sizes : undefined}
        alt={alt}
        title={alt}
        loading={eager ? 'eager' : 'lazy'}
        fetchPriority={priority}
        decoding="async"
        onLoad={() => setLoaded(true)}
        className={`transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
      />
    </div>
  );
}